module.exports = __webpack_public_path__ + "img/logo.61cb08c6.png";